/**
 * Script for the Front Page
 *
 * @author Space-Time Inc.
 * @version 2024-02-10
 */


// ============================================
// コア部分（メインロジック）
// ============================================

window.addEventListener('load', () => {
  // 基本設定
  const BASE_WIDTH = 800;
  const BASE_HEIGHT = 850;

  let positions = calculateResponsivePositions();
  const hasSeenLogo = sessionStorage.getItem('hasSeenLogo');

  const cubeRotations = {
    cube1: 90,
    cube2: 120,
    cube3: 45
  };

  const tl = gsap.timeline();

  // メインフロー制御

  gsap.set(".site-logo", { opacity: 0 });
  gsap.set([".fade"], { opacity: 1 });
  initializeCubesForCarousel();
  // if (!hasSeenLogo) {
  //   // 初回訪問：ロゴアニメーション → キューブが左下から入場 → カルーセル開始
  //   sessionStorage.setItem('hasSeenLogo', 'true');
  //   gsap.set([".fade"], { opacity: 0 });
  //   tl.add(runLogoAnimation(), 0);
  //   tl.add(runCubeIntroAnimation(), "-=1.0");
  // } else {
  //   // 2回目以降：ロゴを非表示にして直接カルーセル開始
  //   gsap.set(".site-logo", { opacity: 0 });
  //   gsap.set([".fade"], { opacity: 1 });
  //   initializeCubesForCarousel();
  // }


  // キューブ位置追跡
  let cubePositions = {
    cube1: 1,
    cube2: 2,
    cube3: 3
  };

  let isFirstLoop = true;
  let carouselTimeline = null;
  let floatingTweens = [];

  // ============================================
  // アニメーション実行関数（コア）
  // ============================================

  // ロゴアニメーション
  function runLogoAnimation() {
    const tl = gsap.timeline();

    const promise = new Promise((resolve) => {
      tl.fromTo(".site-logo",
        { opacity: 0 },
        { opacity: 1, duration: 0.5, ease: "power1.inOut" }
      )
      .to({}, { duration: 2 })
      .to(".site-logo", {
        opacity: 0,
        duration: 3,
        ease: "power1.inOut",
        onComplete: resolve
      }, "+=0");
    });

    // Promiseも返す場合（必要に応じて）
    tl.promise = promise;
    return tl;
  }

  // 初回訪問時：キューブが左下から入ってくるアニメーション
  function runCubeIntroAnimation() {
    // 画面サイズを取得して左下の位置を計算
    const vh = window.innerHeight;
    const startX = -500; // 左外
    const startY = vh + 500; // 下外

    // 初期状態セット
    gsap.set([".cube1-wrapper", ".cube2-wrapper", ".cube3-wrapper"], {
      x: startX,
      y: startY,
      width: BASE_WIDTH * 2,
      height: BASE_HEIGHT * 2,
      opacity: 1
    });

    gsap.set([".cube1", ".cube2", ".cube3"], {
      rotate: 0
    });

    // タイムライン作成
    const tl = gsap.timeline();

    tl.addLabel("start")
      .to(".cube1-wrapper", {
        x: positions.cube1Final.x,
        y: positions.cube1Final.y,
        width: positions.cube1Final.width,
        height: positions.cube1Final.height,
        duration: 1.5,
        ease: "back.out(1.7)"
      }, "start")
      .to(".cube1", {
        rotate: cubeRotations.cube1,
        duration: 1.5,
        ease: "back.out(1.7)"
      }, "start")

      .to(".cube2-wrapper", {
        x: positions.cube2Final.x,
        y: positions.cube2Final.y,
        width: positions.cube2Final.width,
        height: positions.cube2Final.height,
        duration: 1.5,
        ease: "back.out(1.7)"
      }, "start")
      .to(".cube2", {
        rotate: cubeRotations.cube2,
        duration: 1.5,
        ease: "back.out(1.7)"
      }, "start")

      .to(".cube3-wrapper", {
        x: positions.cube3Final.x,
        y: positions.cube3Final.y,
        width: positions.cube3Final.width,
        height: positions.cube3Final.height,
        duration: 1.5,
        ease: "back.out(1.7)"
      }, "start")
      .to(".cube3", {
        rotate: cubeRotations.cube3,
        duration: 1.5,
        ease: "back.out(1.7)"
      }, "start")
      .to([".main-copy", ".sub-copy"], {
        opacity: 1,
        duration: 1,
        ease: "power1.inOut"
      })
      .call(updateInnerOpacity)
      .to({}, { duration: 0.5 }) 
      .to([".tv-button",".tv-list"], {
        opacity: 1,
        duration: 1,
        ease: "power1.inOut"
      }, "+=0.5")
      .to([".site-header"], {
        opacity:1,
        duration: 1,
        ease: "power1.inOut"
      })
      .call(() => {
        document.querySelectorAll(".item-tv-list").forEach(el => {
          el.classList.add("active");
          el.querySelectorAll('.fade').forEach(fadeEl => {
            setTimeout(() => {
              fadeEl.style.opacity = "1";
            }, 500);
          });
        });
      })

      .call(() => startCarouselLoop());

    return tl;
  }
  // カルーセルループのメイン処理
  function startCarouselLoop({ skipUpdateInnerOpacity = false } = {}) {
    if (carouselTimeline) {
      carouselTimeline.kill();
    }

    carouselTimeline = gsap.timeline({ repeat: -1, repeatDelay: 3 });

    carouselTimeline.call(() => {
      if (!isFirstLoop) {
        rotatePositions();
      }

      updateCubeSizes();
      if (!skipUpdateInnerOpacity) {
        updateInnerOpacity();
      }
      updateCubeZIndex(); 
      stopFloatingAnimation();

      // 位置移動アニメーション
      const c1 = getPositionInfo(cubePositions.cube1);
      const c2 = getPositionInfo(cubePositions.cube2);
      const c3 = getPositionInfo(cubePositions.cube3);
      gsap.to("#preloader", {
          zIndex: -1,
          duration: 0.3
      });
      gsap.to(".cube1-wrapper", { 
        duration: 0.5, x: c1.x, y: c1.y, width: c1.width, height: c1.height
      });
      gsap.to(".cube2-wrapper", { 
        duration: 0.5, x: c2.x, y: c2.y, width: c2.width, height: c2.height
      });
      gsap.to(".cube3-wrapper", { 
        duration: 0.5, x: c3.x, y: c3.y, width: c3.width, height: c3.height
      });

      // 回転アニメーション
      gsap.to(".cube1", { duration: 0.5, rotate: cubeRotations.cube1, ease: "power2.inOut" });
      gsap.to(".cube2", { duration: 0.5, rotate: cubeRotations.cube2, ease: "power2.inOut" });
      gsap.to(".cube3", { duration: 0.5, rotate: cubeRotations.cube3, ease: "power2.inOut" });

      // 回転角度を更新
      cubeRotations.cube1 += ROTATION_STEP.cube1;
      cubeRotations.cube2 += ROTATION_STEP.cube2;
      cubeRotations.cube3 += ROTATION_STEP.cube3;

      isFirstLoop = false;
    })
    .call(() => {
      startFloatingAnimation();
    }, null, '+=0.5');
  }

  // ============================================
  // 補助的な関数群
  // ============================================

  // レスポンシブ位置計算
  function calculateResponsivePositions() {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let cube1Final, cube2Final, cube3Final;

    if (vw <= 600) {
      // スマホサイズ
      cube2Final = { x: vw * 0.125, y: vh * 0.1, width: BASE_WIDTH * 0.5, height: BASE_HEIGHT * 0.5 };

      cube3Final = { x: 0, y: vh * 0.1, width: BASE_WIDTH * 0.2, height: BASE_HEIGHT * 0.2 };
      cube1Final = { x: vw * 0.8, y: vh * 0.1, width: BASE_WIDTH * 0.2, height: BASE_HEIGHT * 0.2 };
    } else if (vw > 600 && vw <= 900) {
      // タブレット・小さめPC
      const largeScale = (vw * 0.6) / BASE_WIDTH;
      const largeW = BASE_WIDTH * largeScale;
      const largeH = BASE_HEIGHT * largeScale;
      const smallScale = largeScale * 0.45;
      const smallW = BASE_WIDTH * smallScale;
      const smallH = BASE_HEIGHT * smallScale;
      const totalWidth = smallW + largeW;
      const startX = vw * 0.5 - totalWidth;
      const largeCenterY = (vh - largeH) / 2 + 150;
      const rightMargin = vw * 0.2;
      const topMargin = vh * 0.2;

      cube2Final = { x: startX + largeW + rightMargin, y: largeCenterY - 0.15 * vh, width: largeW, height: largeH };
   //   const smallCubeY = -smallH * 0.1;
      cube3Final = { x: startX - smallW + largeW, y: 0.1 * vh, width: smallW, height: smallH };
      cube1Final = { x: 0.8 * vw, y: largeCenterY - 2 * topMargin, width: smallW, height: smallH };
    } else if (vw > 900 && vw <= 1200) {
      // タブレット・小さめPC
      const largeScale = (vw * 0.8) / BASE_WIDTH;
      const largeW = BASE_WIDTH * largeScale;
      const largeH = BASE_HEIGHT * largeScale;
      const smallScale = largeScale * 0.45;
      const smallW = BASE_WIDTH * smallScale;
      const smallH = BASE_HEIGHT * smallScale;
      const totalWidth = smallW + largeW;
      const startX = vw * 0.5 - totalWidth;
      const largeCenterY = (vh - largeH) / 2 + 150;
      const rightMargin = vw * 0.2;
      const topMargin = vh * 0.2;

      cube2Final = { x: startX + largeW + rightMargin, y: largeCenterY - 0.15 * vh, width: largeW, height: largeH };
   //   const smallCubeY = -smallH * 0.1;
      cube3Final = { x: startX - smallW + largeW, y: 0.1 * vh, width: smallW, height: smallH };
      cube1Final = { x: 0.8 * vw, y: largeCenterY - 2 * topMargin, width: smallW, height: smallH };
    } 
    
    else {
      // PCサイズ
      const largeScale = (vw * 0.475) / BASE_WIDTH;
      const largeW = BASE_WIDTH * largeScale;
      const largeH = BASE_HEIGHT * largeScale;
      const smallScale = largeScale * 0.5;
      const smallW = BASE_WIDTH * smallScale;
      const smallH = BASE_HEIGHT * smallScale;
      const totalWidth = smallW + largeW;
      const startX = vw * 0.75 - totalWidth;
      const largeCenterY = (vh - largeH) / 2;
      const rightMargin = 0;
      const topMargin = vh * 0.05;

      cube2Final = { x: startX + largeW - rightMargin, y: largeCenterY + topMargin, width: largeW, height: largeH };
      const smallCubeY = -smallH * 0.3;
      cube1Final = { x: startX + 1.75 * smallW + largeW, y: largeCenterY + smallCubeY, width: smallW, height: smallH };
      cube3Final = { x: largeW - smallW/2, y: largeCenterY + smallCubeY, width: smallW, height: smallH };
    }
    return { cube1Final, cube2Final, cube3Final };
  }

  // 2回目以降訪問時：キューブを最初の位置に配置
  function initializeCubesForCarousel() {
    return new Promise((resolve) => {
      gsap.set(".cube1-wrapper", {
        x: positions.cube1Final.x, y: positions.cube1Final.y,
        width: positions.cube1Final.width, height: positions.cube1Final.height, opacity: 1
      });
      gsap.set(".cube2-wrapper", {
        x: positions.cube2Final.x, y: positions.cube2Final.y,
        width: positions.cube2Final.width, height: positions.cube2Final.height, opacity: 1
      });
      gsap.set(".cube3-wrapper", {
        x: positions.cube3Final.x, y: positions.cube3Final.y,
        width: positions.cube3Final.width, height: positions.cube3Final.height, opacity: 1
      });

      gsap.set(".cube1", { rotate: cubeRotations.cube1 });
      gsap.set(".cube2", { rotate: cubeRotations.cube2 });
      gsap.set(".cube3", { rotate: cubeRotations.cube3 });
      
      tl.call(() => {
        updateInnerOpacity();
        updateCubeZIndex(); 
        startCarouselLoop();
        resolve();
      });


    });
  }

  // 位置情報取得
  function getPositionInfo(pos) {
    const currentPositions = positions;
    
    switch (pos) {
      case 1:
        return {
          x: currentPositions.cube1Final.x, y: currentPositions.cube1Final.y,
          width: currentPositions.cube1Final.width, height: currentPositions.cube1Final.height
        };
      case 2:
        return {
          x: currentPositions.cube2Final.x, y: currentPositions.cube2Final.y,
          width: currentPositions.cube2Final.width, height: currentPositions.cube2Final.height
        };
      case 3:
        return {
          x: currentPositions.cube3Final.x, y: currentPositions.cube3Final.y,
          width: currentPositions.cube3Final.width, height: currentPositions.cube3Final.height
        };
    }
  }

  // 位置ローテーション
  function rotatePositions() {
    const temp = cubePositions.cube1;
    cubePositions.cube1 = cubePositions.cube2;
    cubePositions.cube2 = cubePositions.cube3;
    cubePositions.cube3 = temp;
  }

  // キューブサイズ更新
  function updateCubeSizes() {
    const largeSize = BASE_WIDTH;
    const smallSize = BASE_WIDTH * 0.3;

    ['cube1', 'cube2', 'cube3'].forEach((name) => {
      const wrapper = document.querySelector(`.${name}-wrapper`);
      const pos = cubePositions[name];
      const targetSize = (pos === 2) ? largeSize : smallSize;

      gsap.to(wrapper, {
        width: targetSize, height: targetSize,
        duration: 0.3, ease: "power2.inOut"
      });
    });
  }

  // Inner要素の透明度更新
  function updateInnerOpacity() {
    ['cube1', 'cube2', 'cube3'].forEach((name) => {
      const inner = document.querySelector(`.${name}-wrapper .inner`);
      if (!inner) return;

      const pos = cubePositions[name];
      gsap.to(inner, {
        opacity: (pos === 2) ? 1 : 0,
        duration: 0.5, ease: "power2.out"
      });
    });
  }

  // フローティングアニメーション制御
  function startFloatingAnimation() {
    floatingTweens.forEach(tween => tween.kill());
    floatingTweens = [];

    floatingTweens.push(
      gsap.to(".cube1-wrapper", {
        duration: 1.2, y: "+=6", ease: "sine.inOut",
        yoyo: true, repeat: -1, delay: 0.2
      })
    );
    floatingTweens.push(
      gsap.to(".cube2-wrapper", {
        duration: 1.8, y: "+=10", ease: "sine.inOut",
        yoyo: true, repeat: -1, delay: 0.1
      })
    );
    floatingTweens.push(
      gsap.to(".cube3-wrapper", {
        duration: 1.6, x: "+=4", y: "+=5", ease: "sine.inOut",
        yoyo: true, repeat: -1, delay: 0.4
      })
    );
  }

  function stopFloatingAnimation() {
    floatingTweens.forEach(tween => tween.kill());
    floatingTweens = [];
  }

  function updateCubeZIndex() {
  ['cube1', 'cube2', 'cube3'].forEach((name) => {
    const wrapper = document.querySelector(`.${name}-wrapper`);
    const pos = cubePositions[name];

    // 真ん中（pos === 2）のときだけ前面へ
    gsap.set(wrapper, {
      zIndex: (pos === 2) ? 2 : 1
    });
  });
}

  // リサイズハンドリング
  function handleResize() {
    positions = calculateResponsivePositions();
    
    if (tl.progress() === 1) {
      const c1 = getPositionInfo(cubePositions.cube1);
      const c2 = getPositionInfo(cubePositions.cube2);
      const c3 = getPositionInfo(cubePositions.cube3);

      gsap.set(".cube1-wrapper", { x: c1.x, y: c1.y, width: c1.width, height: c1.height });
      gsap.set(".cube2-wrapper", { x: c2.x, y: c2.y, width: c2.width, height: c2.height });
      gsap.set(".cube3-wrapper", { x: c3.x, y: c3.y, width: c3.width, height: c3.height });
    }
  }

  // 定数
  const ROTATION_STEP = {
    cube1: 90,
    cube2: 120,
    cube3: 45
  };

  // イベントリスナー
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 100);
  });

  window.addEventListener('orientationchange', () => {
    setTimeout(handleResize, 100);
  });
});



document.addEventListener("DOMContentLoaded", () => {
  const alreadyVisited = sessionStorage.getItem("tvListVisited");

  const items = document.querySelectorAll(".item-tv-list");
  items.forEach(item => {
      item.classList.add("active");
      item.querySelectorAll('.fade').forEach(fadeEl => {
          setTimeout(() => {
            fadeEl.style.opacity = "1";
          }, 500);
        });
    });
});
